/* Product page options — snippets/pdp-options, pdp-ring-size, pdp-option-dialogs
   (see assets/ao-pdp-options.css). Loads after ao-pdp.js, which opens and closes the
   dialogs ([data-ao-dialog-open]). Here: the RESIZE list, which drives the hidden
   #pro_resize_size_ring the form submits (the layaway slideout reads and sets that select
   too, with change events both ways); the not-resizable panel; the size guide's chart; the
   Jeweler's Assessment form; and Book a Consultation's times and booking. No Bootstrap
   or jQuery: the page is meant to run without them. */
(function () {
  'use strict';

  /* ---------- RESIZE: an APG select-only combobox over the hidden select ----------
     Focus stays on the combobox; aria-activedescendant follows the arrow keys. */
  function initRing(root) {
    var ring = root.querySelector('[data-ao-ring]');
    if (!ring) return;
    var toggle = ring.querySelector('[data-ao-ring-toggle]');
    var list = ring.querySelector('[role="listbox"]');
    var select = ring.querySelector('#pro_resize_size_ring');
    var valueEl = ring.querySelector('[data-ao-ring-value]');
    if (!toggle) return;

    function isOpen() {
      return ring.classList.contains('is-open');
    }

    // The open list covers Add to Cart: on phones ao-pdp.js shows the floating add-to-cart bar meanwhile
    function announce(was, open) {
      if (was === open) return;
      ring.dispatchEvent(new CustomEvent('ao:ring-toggle', { bubbles: true, detail: { open: open } }));
    }

    // a tap or click anywhere else, or focus leaving the row, closes it
    document.addEventListener('pointerdown', function (e) {
      if (isOpen() && !ring.contains(e.target)) setOpen(false);
    });
    ring.addEventListener('focusout', function (e) {
      if (isOpen() && !ring.contains(e.relatedTarget)) setOpen(false);
    });

    // Not resizable: the toggle is a disclosure button over the reason and the assessment link
    if (!list || !select) {
      var setOpenFixed = function (open) {
        var was = isOpen();
        ring.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        announce(was, open);
      };
      var setOpen = setOpenFixed;
      toggle.addEventListener('click', function () {
        setOpen(!isOpen());
      });
      ring.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
          setOpen(false);
          toggle.focus();
        }
      });
      // The assessment dialog was opened from inside the panel, which has closed since, so
      // ao-pdp.js can't hand focus back to its link: send it to the toggle. (When 'close'
      // fires, focus can still sit on the closed dialog's button, not yet on <body>.)
      var assess = document.getElementById('ao-pdp-assess');
      if (assess) {
        assess.addEventListener('close', function () {
          var a = document.activeElement;
          if (!a || a === document.body || assess.contains(a) || a.closest('[data-ao-ring-pop]')) {
            toggle.focus({ preventScroll: true });
          }
        });
      }
      return;
    }

    var options = [].slice.call(list.querySelectorAll('[role="option"]'));
    var active = null;
    var typed = '';
    var typedTimer = 0;

    function selectedOption() {
      return list.querySelector('[aria-selected="true"]') || options[0];
    }

    function keepInView(opt, centre) {
      var top = opt.offsetTop;
      var bottom = top + opt.offsetHeight;
      if (centre) list.scrollTop = top - (list.clientHeight - opt.offsetHeight) / 2;
      else if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    }

    function setActive(opt, centre) {
      if (active) active.classList.remove('is-active');
      active = opt || null;
      if (!active) {
        toggle.removeAttribute('aria-activedescendant');
        return;
      }
      active.classList.add('is-active');
      toggle.setAttribute('aria-activedescendant', active.id);
      keepInView(active, centre);
    }

    // The list's scrollbar, drawn over the rows so their lines reach the right edge (a native
    // one takes a gutter beside them). Wheel, touch and keys scroll the list; the bar follows,
    // and can be dragged, or clicked above or below the thumb to jump there.
    var bar = ring.querySelector('[data-ao-ring-bar]');
    var thumb = bar && bar.querySelector('[data-ao-ring-thumb]');

    function syncBar() {
      if (!thumb) return;
      var view = list.clientHeight;
      var max = list.scrollHeight - view;
      bar.hidden = max <= 0;
      if (max <= 0) return;
      var h = Math.max(24, (view * view) / list.scrollHeight);
      thumb.style.height = h + 'px';
      thumb.style.transform = 'translateY(' + (list.scrollTop / max) * (view - h) + 'px)';
    }

    if (thumb) {
      list.addEventListener('scroll', syncBar, { passive: true });
      window.addEventListener('resize', syncBar);
      // focus stays on the combobox, and a drag selects no text
      bar.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
      bar.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        var max = list.scrollHeight - list.clientHeight;
        var h = thumb.offsetHeight;
        var span = list.clientHeight - h;
        if (max <= 0 || span <= 0) return;
        if (e.target !== thumb) {
          var y = e.clientY - bar.getBoundingClientRect().top;
          list.scrollTop = ((y - h / 2) / span) * max;
        }
        var startY = e.clientY;
        var start = list.scrollTop;
        function drag(ev) {
          list.scrollTop = start + ((ev.clientY - startY) / span) * max;
        }
        function end() {
          bar.removeEventListener('pointermove', drag);
          bar.removeEventListener('pointerup', end);
          bar.removeEventListener('pointercancel', end);
        }
        bar.setPointerCapture(e.pointerId);
        bar.addEventListener('pointermove', drag);
        bar.addEventListener('pointerup', end);
        bar.addEventListener('pointercancel', end);
      });
    }

    function setOpen(open) {
      var was = isOpen();
      ring.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // opened on the chosen size, centred in the list (Figma 374:716)
      setActive(open ? selectedOption() : null, true);
      if (open) syncBar();
      announce(was, open);
    }

    function show(opt) {
      options.forEach(function (o) {
        o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
      });
      valueEl.innerHTML = opt.innerHTML;
    }

    function choose(opt) {
      if (!opt) return;
      show(opt);
      var value = opt.getAttribute('data-value');
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // The layaway slideout sets the select (and a restored page may have kept a pick): follow it
    function follow() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('data-value') === select.value) {
          if (options[i].getAttribute('aria-selected') !== 'true') show(options[i]);
          return;
        }
      }
    }
    select.addEventListener('change', follow);
    follow();

    function move(by) {
      var i = options.indexOf(active || selectedOption());
      setActive(options[Math.max(0, Math.min(options.length - 1, i + by))]);
    }

    // Type a size ("6", "6.7") to jump to it
    function typeahead(ch) {
      clearTimeout(typedTimer);
      typed += ch;
      typedTimer = setTimeout(function () {
        typed = '';
      }, 700);
      for (var i = 0; i < options.length; i++) {
        if (options[i].textContent.trim().indexOf(typed) === 0) {
          if (!isOpen()) setOpen(true);
          setActive(options[i]);
          return;
        }
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });

    list.addEventListener('click', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (!opt) return;
      choose(opt);
      setOpen(false);
      toggle.focus({ preventScroll: true });
    });

    // On the ring, not the toggle: a click on the list's scrollbar can leave focus on the list
    ring.addEventListener('keydown', function (e) {
      var open = isOpen();
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!open) setOpen(true);
          else if (!e.altKey) move(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (!open) setOpen(true);
          else if (e.altKey) {
            choose(active);
            setOpen(false);
          } else move(-1);
          break;
        case 'PageDown':
        case 'PageUp':
          if (!open) return;
          e.preventDefault();
          move(e.key === 'PageDown' ? 6 : -6);
          break;
        case 'Home':
        case 'End':
          e.preventDefault();
          if (!open) setOpen(true);
          setActive(options[e.key === 'Home' ? 0 : options.length - 1]);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (!open) {
            setOpen(true);
            return;
          }
          choose(active);
          setOpen(false);
          toggle.focus({ preventScroll: true });
          break;
        case 'Escape':
          if (!open) return;
          e.preventDefault();
          setOpen(false);
          toggle.focus({ preventScroll: true });
          break;
        case 'Tab':
          if (!open) return;
          choose(active);
          setOpen(false);
          break;
        default:
          if (e.key.length === 1 && /[\d.]/.test(e.key) && !e.ctrlKey && !e.metaKey && !e.altKey) {
            typeahead(e.key);
          }
      }
    });
  }

  /* ---------- Ring Size Guide chart: a whole size opens to its quarter sizes ---------- */
  function initSizeGuide(root) {
    var chart = root.querySelector('[data-ao-sg]');
    if (!chart) return;
    chart.addEventListener('click', function (e) {
      var button = e.target.closest('[data-ao-sg-toggle]');
      if (!button) return;
      var row = button.closest('.ao-sg__row');
      var open = !row.classList.contains('is-open');
      row.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Request a Jeweler's Assessment ----------
     Shopify's contact form, posted in place. Shopify answers a good post with a redirect to
     ?contact_posted=true; if its spam check steps in, submit for real so the shopper can pass
     it (the page then comes back with the thank-you, and this opens the dialog on it).
     Shopify's hCaptcha binds to the form on first focus; a submit then runs the captcha, adds
     its token and calls the form.submit it found when binding, so form.submit is our post.
     Posting from the submit event itself raced it: ours went without the token and failed,
     then the captcha's real submit reloaded the page. */
  function initAssess(root) {
    var form = root.querySelector('#ao-assess-form');
    if (!form) return;

    if (form.querySelector('[data-ao-assess-posted]')) {
      var opener = root.querySelector('[data-ao-dialog-open="ao-pdp-assess"]');
      if (opener) opener.click();
      // Shopify came back with ?contact_posted=true: once the thank-you is closed, take that
      // (and the captcha's form_key/form_type, and the #ao-assess-form jump) out of the
      // address, so a refresh shows the page, not the thank-you again
      form.closest('dialog').addEventListener(
        'close',
        function () {
          try {
            var url = new URL(location.href);
            ['contact_posted', 'form_key', 'form_type'].forEach(function (k) {
              url.searchParams.delete(k);
            });
            if (url.hash === '#ao-assess-form') url.hash = '';
            history.replaceState(history.state, '', url.href);
          } catch (e) {}
        },
        { once: true }
      );
      return;
    }
    if (!window.fetch || !window.FormData) return;

    var dialog = form.closest('dialog');
    var opener = root.querySelector('[data-ao-dialog-open="ao-pdp-assess"]');
    var button = form.querySelector('[type="submit"]');
    var error = form.querySelector('[data-ao-assess-error]');
    var sending = false;
    var watch = null;

    // Grayed out from the click until the post settles (the captcha takes a moment before the
    // post starts). aria-disabled, not disabled, so focus stays on the button.
    function setBusy(on) {
      button.setAttribute('aria-busy', on ? 'true' : 'false');
      button.setAttribute('aria-disabled', on ? 'true' : 'false');
    }
    function fail(err) {
      console.error(err);
      if (error) error.hidden = false;
      setBusy(false);
      sending = false;
    }

    function reopen() {
      if (dialog.classList.contains('is-closing')) return setTimeout(reopen, 100);
      if (!dialog.open && opener) opener.click();
    }

    // When hCaptcha wants a puzzle solved it shows it in a frame on <body>: under the modal
    // dialog, which also makes it unclickable. Step the dialog aside while the puzzle is up; it
    // comes back for the post, or when the puzzle is closed unsolved.
    function puzzleUp() {
      return [].some.call(document.querySelectorAll('iframe[src*="hcaptcha"]'), function (f) {
        return !dialog.contains(f) && f.offsetWidth > 0 && getComputedStyle(f).visibility === 'visible';
      });
    }
    function watchPuzzle() {
      clearInterval(watch);
      var stepped = false;
      var ticks = 0;
      watch = setInterval(function () {
        var up = puzzleUp();
        if (up && !stepped) {
          stepped = true;
          window.aoPdpCloseDialog(dialog);
        } else if (!up && stepped) {
          // Solved, the post follows at once; closed unsolved, nothing comes, so let them retry
          clearInterval(watch);
          reopen();
          setTimeout(function () {
            if (!sending) setBusy(false);
          }, 1500);
        } else if (!up && ++ticks > 120) {
          // No puzzle and no token after 30s: the captcha never answered
          clearInterval(watch);
          if (!sending) fail(new Error('Assessment request not sent: no captcha token'));
        }
      }, 250);
    }

    form.submit = function () {
      clearInterval(watch);
      reopen();
      if (sending) return;
      sending = true;
      setBusy(true);
      if (error) error.hidden = true;

      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          if (/\/challenge/.test(res.url)) {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          if (!res.ok || res.url.indexOf('contact_posted=true') === -1) {
            throw new Error('Assessment request not sent: ' + res.status);
          }
          var done = document.createElement('p');
          done.className = 'ao-assess__done';
          done.setAttribute('role', 'status');
          done.textContent = 'Thank you. Our team will consult with our jeweler and follow up by email.';
          form.replaceChildren(done);
        })
        .catch(fail);
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Already on its way: don't start the captcha again
      if (button.getAttribute('aria-busy') === 'true') {
        e.stopImmediatePropagation();
        return;
      }
      setBusy(true);
      if (error) error.hidden = true;
      // Bound: the captcha's own listener runs next and ends in form.submit()
      if (form.hasAttribute('data-hcaptcha-bound')) {
        watchPuzzle();
        return;
      }
      // Captcha on but not bound yet (sent before it finished loading): bind it, then go through it
      var captcha = window.Shopify && window.Shopify.captcha;
      if (captcha && captcha.protect) {
        watchPuzzle();
        captcha.protect(form, function () {
          form.submit();
        });
        return;
      }
      form.submit();
    });
  }

  /* ---------- Book a Consultation ----------
     The open times come from the layaway backend through the App Proxy (GET …/slots) when the
     panel opens (again after 5 minutes, or after the picked time was taken), shown in the
     shopper's own time zone. Request Consultation books one (POST): the backend puts it on the
     store's Google Calendar and makes sure no two shoppers get the same time. */
  var CONSULT_CONTACT = 'customer.service@abbottoaks.com';

  function initConsult(root) {
    var form = root.querySelector('[data-ao-consult-form]');
    if (!form) return;
    var endpoint = form.getAttribute('data-endpoint') || '/apps/layaway/api/proxy/consultations';
    var dateSel = form.querySelector('[data-ao-consult-date]');
    var timeSel = form.querySelector('[data-ao-consult-time]');
    var button = form.querySelector('.ao-hint__submit');
    var error = form.querySelector('[data-ao-consult-error]');
    var dayFmt = new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
    var timeFmt = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    var zone = '';
    try {
      zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (err) {}
    var byDate = {};
    var loadedAt = 0;
    var loading = null;
    var sending = false;

    function say(text) {
      if (!error) return;
      error.textContent = text || '';
      error.hidden = !text;
    }
    function setBusy(on) {
      button.setAttribute('aria-busy', on ? 'true' : 'false');
      button.setAttribute('aria-disabled', on ? 'true' : 'false');
    }
    // The backend answers { success, data } or { success: false, error: { code, message } }
    function api(path, init) {
      return fetch(endpoint + path, init).then(function (res) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (body) {
            if (!res.ok || !body || body.success === false) {
              var err = new Error((body && body.error && body.error.message) || 'Consultation request failed: ' + res.status);
              err.status = res.status;
              err.code = body && body.error && body.error.code;
              throw err;
            }
            return body.data;
          });
      });
    }

    // The shopper's own calendar date, so a time is listed under the day it is for them
    function dayKey(iso) {
      var d = new Date(iso);
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    }
    function fillTimes() {
      var keep = timeSel.value;
      timeSel.length = 1;
      (byDate[dateSel.value] || []).forEach(function (s) {
        timeSel.add(new Option(timeFmt.format(new Date(s.start)), s.start));
      });
      timeSel.value = keep;
      if (timeSel.selectedIndex < 1) timeSel.selectedIndex = 0;
      timeSel.disabled = !dateSel.value;
    }
    function fillDates(slots) {
      var keep = dateSel.value;
      byDate = {};
      dateSel.length = 1;
      slots.forEach(function (s) {
        var key = dayKey(s.start);
        if (!byDate[key]) {
          byDate[key] = [];
          dateSel.add(new Option(dayFmt.format(new Date(s.start)), key));
        }
        byDate[key].push(s);
      });
      dateSel.value = keep;
      if (dateSel.selectedIndex < 1) dateSel.selectedIndex = 0;
      dateSel.disabled = !slots.length;
      fillTimes();
    }

    function load() {
      if (loading) return loading;
      dateSel.disabled = true;
      timeSel.disabled = true;
      dateSel.options[0].textContent = 'Loading Dates…';
      loading = api('/slots', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (data) {
          var slots = (data && data.enabled && data.slots) || [];
          loadedAt = Date.now();
          dateSel.options[0].textContent = slots.length ? 'Select Date' : 'No Dates Available';
          fillDates(slots);
          if (!slots.length) {
            say('No consultation times are open right now. Please email us at ' + CONSULT_CONTACT + ' and we’ll find a time.');
          }
        })
        .catch(function (err) {
          console.error(err);
          dateSel.options[0].textContent = 'Select Date';
          say('We couldn’t load the available times. Please close this and try again.');
        })
        .then(function () {
          loading = null;
        });
      return loading;
    }

    root.querySelectorAll('[data-ao-dialog-open="ao-pdp-consult"]').forEach(function (opener) {
      opener.addEventListener('click', function () {
        if (sending || Date.now() - loadedAt < 5 * 60 * 1000) return;
        say('');
        load();
      });
    });
    dateSel.addEventListener('change', function () {
      fillTimes();
      say('');
    });
    timeSel.addEventListener('change', function () {
      say('');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending || !timeSel.value) return;
      sending = true;
      setBusy(true);
      say('');
      var fields = new FormData(form);
      var start = timeSel.value;
      var name = String(fields.get('first_name') || '').trim();
      var email = String(fields.get('email') || '').trim();
      var notes = String(fields.get('notes') || '').trim();
      api('', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          start: start,
          first_name: name,
          email: email,
          notes: notes || undefined,
          piece_title: fields.get('piece_title') || undefined,
          piece_url: fields.get('piece_url') || undefined,
          piece_sku: fields.get('piece_sku') || undefined,
          time_zone: zone || undefined,
          website: String(fields.get('website') || ''),
        }),
      }).then(
        function (booking) {
          // The form gives way to the "received" card (Figma 702:2 / 702:50). Focus goes to its
          // heading so the submit button's focus isn't lost to <body>.
          var at = new Date(start);
          var invited = booking && booking.invited;
          var card = document.createElement('div');
          card.className = 'ao-consult__done';
          var heading = document.createElement('h3');
          heading.className = 'ao-consult__heading';
          heading.tabIndex = -1;
          heading.textContent = 'We’ve Received Your Request';
          var when = document.createElement('strong');
          when.textContent = dayFmt.format(at) + ' at ' + timeFmt.format(at);
          var thanks = document.createElement('p');
          thanks.append(
            'Thank you, ' + name + '! Your consultation for ',
            when,
            invited ? ' is booked.' : ' is pending confirmation from our team.'
          );
          var next = document.createElement('p');
          next.textContent = invited
            ? 'A calendar invitation with a link to join your virtual appointment is on its way to ' + email + '.'
            : 'Once confirmed, we’ll send ' + email + ' a calendar invitation with a link to join your virtual appointment.';
          card.append(heading, thanks, next);
          form.replaceWith(card);
          // The card stands alone: the Closer Look intro above it goes (the user, 2026-10-24)
          while (card.previousElementSibling) card.previousElementSibling.remove();
          // Back to the top of the panel, which is now short: the shopper was scrolled down at the
          // button, and on iPhones the panel stayed there with the card under the sticky header
          var panel = card.closest('dialog');
          if (panel) panel.scrollTop = 0;
          heading.focus({ preventScroll: true });
        },
        function (err) {
          console.error(err);
          sending = false;
          setBusy(false);
          if (err.code === 'SLOT_TAKEN') {
            say('That time was just booked. Please choose another.');
            loadedAt = 0;
            load();
          } else if (err.status === 409 || err.status === 429) {
            say(err.message);
          } else {
            say('Sorry, we couldn’t book that time. Please try again, or email us at ' + CONSULT_CONTACT + '.');
          }
        }
      );
    });
  }

  function init(root) {
    if (!root || root.__aoPdpOptions) return;
    root.__aoPdpOptions = true;
    initRing(root);
    initSizeGuide(root);
    initAssess(root);
    initConsult(root);
  }

  document.querySelectorAll('[data-ao-pdp]').forEach(init);
  // Theme editor re-renders
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-ao-pdp]'));
  });
})();
